import {
  queryConfessionWallApi,
  getConfessionWallByIdApi,
  deleteConfessionWallApi,
  setConfessionWallMsgApi,
  queryConfessionWallEvaluateApi,
  setWithdrawConfigApi,
  addGroupApi,
  deleteGroupApi,
  updateGroupApi,
  queryGroupApi,
  queryGroupRelShopApi,
  groupAddShopRelApplyApi,
  setGroupWxPayAccountMsgApi,
  getGroupWxPayAccountMsgByGroupIdApi,
  queryBrandGroupRelApi,
  queryGroupBalanceWaterApi,
  groupReserveFundTransferToShopApi,
  getReserveFundCommissionCountApi,
  deleteCustServiceApi,
  addCustServiceApi,
  queryCustServiceApi,
  addAutoReplyRuleApi,
  deleteAutoReplyRuleApi,
  updateAutoReplyRuleApi,
  getAutoReplyRuleByIdApi,
  queryAutoReplyRuleApi,
  queryCustServiceMsgItemApi,
  addExpressConfigApi,
  deleteExpressConfigApi,
  setExpressConfigTopApi,
  queryExpressConfigListApi,
  queryExpressListApi,
  addBuildingApi,
  deleteBuildingApi,
  setBuildingMsgApi,
  getBuildingListApi,
  applyForWithdrawalCommonApi,
  setIsBanWordApi,
  queryConfessionWallReportApi,
  getGxOrderTotalStatisticsApi,
  queryGxOrderByDayStatisticsApi,
  queryGxGoodsSalesStatisticsApi,
  getGxOrderCountGroupByShopApi,
  getGxOrderCountByDayForGroupApi,
  getGxGoodsSalesStatisticsApi,
  queryOrderErrandFloorConfigApi,
  addErrandBasketApi,
  updateErrandBasketApi,
  deleteErrandBasketApi,
  queryErrandBasketApi,
  gxBatchOrderCompletionApi,
  updateOrderEvaluateApi,
  submitOrderEvaluationApi,
  addGoodsTyingGroupApi,
  deleteGoodsTyingGroupApi,
  updateGoodsTyingGroupApi,
  queryGoodsTyingGroupApi,
  getGoodsTyingGroupListApi,
  getGoodsTyingGroupRelListByGoodsIdApi,
  getKeywordShieldConfigApi,
  saveKeywordShieldConfigApi,
  deleteBrandRelShareShopApi,
  addSnackBoxGoodsApi,
  updateSnackBoxGoodsApi,
  setSnackBoxGoodsIsShelvesApi,
  getSnackBoxGoodsByIdApi,
  getSnackBoxGoodsListApi,
  querySnackBoxGoodsApi,
  addSnackBoxTypeApi,
  deleteSnackBoxTypeApi,
  updateSnackBoxTypeApi,
  getSnackBoxTypeListApi,
  querySnackBoxTypeApi,
  addSnackBoxShopApi,
  updateSnackBoxShopApi,
  deleteSnackBoxShopApi,
  getSnackBoxShopByIdApi,
  querySnackBoxShopApi,
  setSnackBoxShopCreditScoreApi,
  addGoodsRepairTemplateApi,
  deleteGoodsRepairTemplateApi,
  updateGoodsRepairTemplateItemApi,
  getGoodsRepairTemplateAndItemApi,
  getRepairTemplateItemByTemplateConfigApi,
  queryGoodsRepairTemplateApi,
  addSnackBoxGoodsApplyApi,
  querySnackBoxGoodsApplyApi,
  getSnackBoxGoodsApplyItemAndSkuListApi,
  setSnackBoxGoodsApplyHandleStateApi,
  addSnackBoxStockManageApi,
  querySnackBoxStockManageApi,
  getSnackBoxStockManageRelGoodsListApi,
  saveDeliveryCarRelGoodsApi,
  saveSnackBoxStockManageFinishApi,
  recoverySnackBoxAllGoodsApi,
  getSnackBoxInventoryCountApi,
  getSnackBoxDataOverviewApi,
  deleConfessionWallEvaluateApi,
  querySnackBoxGoodsSalesRankingApi,
  queryCompanyOrderAndReserveFundWaterApi,
  getCompanyOrderAndReserveFundWaterCountApi,
  deleteSnackBoxStockManageApi,
  deleteSnackBoxGoodsApplyApi,
  getCustomChargeItemListApi
} from '@/api'
import { RES_OK } from '@/config'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  查询表白墙
  async queryConfessionWallAction(context, param) {
    const res = await queryConfessionWallApi(param)
    return res
  },
  //  根据id获取表白墙
  async getConfessionWallByIdAction(context, param) {
    const res = await getConfessionWallByIdApi(param)
    return res
  },
  //  删除表白墙
  async deleteConfessionWallAction(context, param) {
    const res = await deleteConfessionWallApi(param)
    return res
  },
  //  设置表白墙信息
  async setConfessionWallMsgAction(context, param) {
    const res = await setConfessionWallMsgApi(param)
    return res
  },
  //  查询表白墙评论
  async queryConfessionWallEvaluateAction(context, param) {
    const res = await queryConfessionWallEvaluateApi(param)
    return res
  },
  //  设置提现配置
  async setWithdrawConfigAction(context, param) {
    const res = await setWithdrawConfigApi(param)
    return res
  },
  //  添加集团
  async addGroupAction(context, param) {
    const res = await addGroupApi(param)
    return res
  },
  //  删除集团
  async deleteGroupAction(context, param) {
    const res = await deleteGroupApi(param)
    return res
  },
  //  更新集团
  async updateGroupAction(context, param) {
    const res = await updateGroupApi(param)
    return res
  },
  //  查询集团
  async queryGroupAction(context, param) {
    const res = await queryGroupApi(param)
    return res
  },
  //  查询集团关联的门店
  async queryGroupRelShopAction(context, param) {
    const res = await queryGroupRelShopApi(param)
    return res
  },
  //  集团添加门店申请
  async groupAddShopRelApplyAction(context, param) {
    const res = await groupAddShopRelApplyApi(param)
    return res
  },
  //  设置集团微信支付账号信息
  async setGroupWxPayAccountMsgAction(context, param) {
    const res = await setGroupWxPayAccountMsgApi(param)
    return res
  },
  //  根据集团id获取集团微信支付账号信息
  async getGroupWxPayAccountMsgByGroupIdAction(context, param) {
    const res = await getGroupWxPayAccountMsgByGroupIdApi(param)
    return res
  },
  //  查询品牌集团关联
  async queryBrandGroupRelAction(context, param) {
    const res = await queryBrandGroupRelApi(param)
    return res
  },
  //  查询集团余额流水
  async queryGroupBalanceWaterAction(context, param) {
    const res = await queryGroupBalanceWaterApi(param)
    return res
  },
  //  集团储备金划拨到门店
  async groupReserveFundTransferToShopAction(context, param) {
    const res = await groupReserveFundTransferToShopApi(param)
    return res
  },
  //  获取储备金抽成统计
  async getReserveFundCommissionCountAction(context, param) {
    const res = await getReserveFundCommissionCountApi(param)
    return res
  },
  //  删除客服信息
  async deleteCustServiceAction(context, param) {
    const res = await deleteCustServiceApi(param)
    return res
  },
  // 添加客服信息
  async addCustServiceAction(context, param) {
    const res = await addCustServiceApi(param)
    return res
  },
  // 查询客服信息
  async queryCustServiceAction(context, param) {
    const res = await queryCustServiceApi(param)
    return res
  },
  // 添加自动回复规则
  async addAutoReplyRuleAction(context, param) {
    const res = await addAutoReplyRuleApi(param)
    return res
  },
  // 删除自动回复规则
  async deleteAutoReplyRuleAction(context, param) {
    const res = await deleteAutoReplyRuleApi(param)
    return res
  },
  // 更新自动回复规则
  async updateAutoReplyRuleAction(context, param) {
    const res = await updateAutoReplyRuleApi(param)
    return res
  },
  // 根据id获取自动回复规则
  async getAutoReplyRuleByIdAction(context, param) {
    const res = await getAutoReplyRuleByIdApi(param)
    return res
  },
  // 查询自动回复规则
  async queryAutoReplyRuleAction(context, param) {
    const res = await queryAutoReplyRuleApi(param)
    return res
  },
  // 查询客服消息条目
  async queryCustServiceMsgItemAction(context, param) {
    const res = await queryCustServiceMsgItemApi(param)
    return res
  },
  // 添加高校快递代取配置
  async addExpressConfigAction(context, param) {
    const res = await addExpressConfigApi(param)
    return res
  },
  // 删除高校快递代取配置
  async deleteExpressConfigAction(context, param) {
    const res = await deleteExpressConfigApi(param)
    return res
  },
  // 设置高校快递代取配置置顶
  async setExpressConfigTopAction(context, param) {
    const res = await setExpressConfigTopApi(param)
    return res
  },
  // 查询高校快递代取配置列表
  async queryExpressConfigListAction(context, param) {
    const res = await queryExpressConfigListApi(param)
    return res
  },
  // 查询代取快递列表
  async queryExpressListAction(context, param) {
    const res = await queryExpressListApi(param)
    return res
  },
  // 添加楼栋
  async addBuildingAction(context, param) {
    const res = await addBuildingApi(param)
    return res
  },
  // 删除楼栋
  async deleteBuildingAction(context, param) {
    const res = await deleteBuildingApi(param)
    return res
  },
  // 设置楼栋信息
  async setBuildingMsgAction(context, param) {
    const res = await setBuildingMsgApi(param)
    return res
  },
  // 获取楼栋列表
  async getBuildingListAction(context, param) {
    const res = await getBuildingListApi(param)
    return res
  },
  // 提现申请——高校
  async applyForWithdrawalCommonAction(context, param) {
    const res = await applyForWithdrawalCommonApi(param)
    return res
  },
  // 设置是否禁言
  async setIsBanWordAction(context, param) {
    const res = await setIsBanWordApi(param)
    return res
  },
  // 查询表白墙举报
  async queryConfessionWallReportAction(context, param) {
    const res = await queryConfessionWallReportApi(param)
    return res
  },
  // 获取高校订单总统计
  async getGxOrderTotalStatisticsAction(context, param) {
    const res = await getGxOrderTotalStatisticsApi(param)
    return res
  },
  // 查询高校订单按天统计
  async queryGxOrderByDayStatisticsAction(context, param) {
    const res = await queryGxOrderByDayStatisticsApi(param)
    return res
  },
  // 查询高校商品销量统计
  async queryGxGoodsSalesStatisticsAction(context, param) {
    const res = await queryGxGoodsSalesStatisticsApi(param)
    return res
  },
  // 按门店分组统计高校订单
  async getGxOrderCountGroupByShopAction(context, param) {
    const res = await getGxOrderCountGroupByShopApi(param)
    return res
  },
  // 按天获取高校订单统计(用于集团)
  async getGxOrderCountByDayForGroupAction(context, param) {
    const res = await getGxOrderCountByDayForGroupApi(param)
    return res
  },
  // 获取高校商品销量统计
  async getGxGoodsSalesStatisticsAction(context, param) {
    const res = await getGxGoodsSalesStatisticsApi(param)
    return res
  },
  // 获取高校商品销量统计
  async queryOrderErrandFloorConfigAction(context, param) {
    const res = await queryOrderErrandFloorConfigApi(param)
    return res
  },
  // 添加中转篮子
  async addErrandBasketAction(context, param) {
    const res = await addErrandBasketApi(param)
    return res
  },
  // 修改中转篮子
  async updateErrandBasketAction(context, param) {
    const res = await updateErrandBasketApi(param)
    return res
  },
  // 删除中转篮子
  async deleteErrandBasketAction(context, param) {
    const res = await deleteErrandBasketApi(param)
    return res
  },
  // 查询中转篮子
  async queryErrandBasketAction(context, param) {
    const res = await queryErrandBasketApi(param)
    return res
  },
  // 批量完成订单
  async gxBatchOrderCompletionAction(context, param) {
    const res = await gxBatchOrderCompletionApi(param)
    return res
  },
  // 回复门店评价
  async updateOrderEvaluateAction(context, param) {
    const res = await updateOrderEvaluateApi(param)
    return res
  },
  // 新增评价
  async submitOrderEvaluationAction(context, param) {
    const res = await submitOrderEvaluationApi(param)
    return res
  },
  // 添加商品搭售分组
  async addGoodsTyingGroupAction(context, param) {
    const res = await addGoodsTyingGroupApi(param)
    return res
  },
  // 删除商品搭售分组
  async deleteGoodsTyingGroupAction(context, param) {
    const res = await deleteGoodsTyingGroupApi(param)
    return res
  },
  // 更新商品搭售分组
  async updateGoodsTyingGroupAction(context, param) {
    const res = await updateGoodsTyingGroupApi(param)
    return res
  },
  // 查询商品搭售分组
  async queryGoodsTyingGroupAction(context, param) {
    const res = await queryGoodsTyingGroupApi(param)
    return res
  },
  // 获取商品搭售分组列表
  async getGoodsTyingGroupListAction(context, param) {
    const res = await getGoodsTyingGroupListApi(param)
    return res
  },
  // 根据商品id获取商品关联的搭售分组列表
  async getGoodsTyingGroupRelListByGoodsIdAction(context, param) {
    const res = await getGoodsTyingGroupRelListByGoodsIdApi(param)
    return res
  },
  // 获取关键词屏蔽配置
  async getKeywordShieldConfigAction(context, param) {
    const res = await getKeywordShieldConfigApi(param)
    return res
  },
  // 添加关键词屏蔽配置
  async saveKeywordShieldConfigAction(context, param) {
    const res = await saveKeywordShieldConfigApi(param)
    return res
  },
  // 删除品牌关联共享门店
  async deleteBrandRelShareShopAction(context, param) {
    const res = await deleteBrandRelShareShopApi(param)
    return res
  },
  // 添加零食盒子商品
  async addSnackBoxGoodsAction(context, param) {
    const res = await addSnackBoxGoodsApi(param)
    return res
  },
  // 修改零食盒子商品
  async updateSnackBoxGoodsAction(context, param) {
    const res = await updateSnackBoxGoodsApi(param)
    return res
  },
  // 设置零食盒子商品是否上架
  async setSnackBoxGoodsIsShelvesAction(context, param) {
    const res = await setSnackBoxGoodsIsShelvesApi(param)
    return res
  },
  // 根据id获取零食盒子商品
  async getSnackBoxGoodsByIdAction(context, param) {
    const res = await getSnackBoxGoodsByIdApi(param)
    return res
  },
  // 获取零食盒子商品列表
  async getSnackBoxGoodsListAction(context, param) {
    const res = await getSnackBoxGoodsListApi(param)
    return res
  },
  // 查询零食盒子商品
  async querySnackBoxGoodsAction(context, param) {
    const res = await querySnackBoxGoodsApi(param)
    return res
  },
  // 添加零食盒子分类
  async addSnackBoxTypeAction(context, param) {
    const res = await addSnackBoxTypeApi(param)
    return res
  },
  // 删除零食盒子分类
  async deleteSnackBoxTypeAction(context, param) {
    const res = await deleteSnackBoxTypeApi(param)
    return res
  },
  // 修改零食盒子分类
  async updateSnackBoxTypeAction(context, param) {
    const res = await updateSnackBoxTypeApi(param)
    return res
  },
  // 获取零食盒子分类列表
  async getSnackBoxTypeListAction(context, param) {
    const res = await getSnackBoxTypeListApi(param)
    return res
  },
  // 查询零食盒子分类
  async querySnackBoxTypeAction(context, param) {
    const res = await querySnackBoxTypeApi(param)
    return res
  },
  // 添加零食盒子门店
  async addSnackBoxShopAction(context, param) {
    const res = await addSnackBoxShopApi(param)
    return res
  },
  // 修改零食盒子门店
  async updateSnackBoxShopAction(context, param) {
    const res = await updateSnackBoxShopApi(param)
    return res
  },
  // 删除零食盒子门店
  async deleteSnackBoxShopAction(context, param) {
    const res = await deleteSnackBoxShopApi(param)
    return res
  },
  // 根据id获取零食盒子门店
  async getSnackBoxShopByIdAction(context, param) {
    const res = await getSnackBoxShopByIdApi(param)
    return res
  },
  // 查询零食盒子门店 — 统计规则
  async querySnackBoxShopAction(context, param) {
    const res = await querySnackBoxShopApi(param)
    return res
  },
  // 设置零食盒子门店信用分
  async setSnackBoxShopCreditScoreAction(context, param) {
    const res = await setSnackBoxShopCreditScoreApi(param)
    return res
  },
  // 添加商品补货模板
  async addGoodsRepairTemplateAction(context, param) {
    const res = await addGoodsRepairTemplateApi(param)
    return res
  },
  // 删除商品补货模板
  async deleteGoodsRepairTemplateAction(context, param) {
    const res = await deleteGoodsRepairTemplateApi(param)
    return res
  },
  // 修改商品补货模板条目
  async updateGoodsRepairTemplateItemAction(context, param) {
    const res = await updateGoodsRepairTemplateItemApi(param)
    return res
  },
  // 获取商品补货模板和条目
  async getGoodsRepairTemplateAndItemAction(context, param) {
    const res = await getGoodsRepairTemplateAndItemApi(param)
    return res
  },
  // 根据模板配置获取补货模板条目
  async getRepairTemplateItemByTemplateConfigAction(context, param) {
    const res = await getRepairTemplateItemByTemplateConfigApi(param)
    return res
  },
  // 查询商品补货模板
  async queryGoodsRepairTemplateAction(context, param) {
    const res = await queryGoodsRepairTemplateApi(param)
    return res
  },
  // 添加零食盒子商品相关申请
  async addSnackBoxGoodsApplyAction(context, param) {
    const res = await addSnackBoxGoodsApplyApi(param)
    return res
  },
  // 查询零食盒子商品相关申请
  async querySnackBoxGoodsApplyAction(context, param) {
    const res = await querySnackBoxGoodsApplyApi(param)
    return res
  },
  // 零食盒子商品相关申请条目和sku列表
  async getSnackBoxGoodsApplyItemAndSkuListAction(context, param) {
    const res = await getSnackBoxGoodsApplyItemAndSkuListApi(param)
    return res
  },
  // 设置零食盒子商品相关申请处理状态
  async setSnackBoxGoodsApplyHandleStateAction(context, param) {
    const res = await setSnackBoxGoodsApplyHandleStateApi(param)
    return res
  },
  // 添加零食盒子库存管理
  async addSnackBoxStockManageAction(context, param) {
    const res = await addSnackBoxStockManageApi(param)
    return res
  },
  // 查询零食盒子库存管理
  async querySnackBoxStockManageAction(context, param) {
    const res = await querySnackBoxStockManageApi(param)
    return res
  },
  // 获取零食盒子库存管理关联商品列表
  async getSnackBoxStockManageRelGoodsListAction(context, param) {
    const res = await getSnackBoxStockManageRelGoodsListApi(param)
    return res
  },
  // 保存配送车关联商品
  async saveDeliveryCarRelGoodsAction(context, param) {
    const res = await saveDeliveryCarRelGoodsApi(param)
    return res
  },
  // 保存零食盒子库存管理完成
  async saveSnackBoxStockManageFinishAction(context, param) {
    const res = await saveSnackBoxStockManageFinishApi(param)
    return res
  },
  // 回收零食盒子全部商品
  async recoverySnackBoxAllGoodsAction(context, param) {
    const res = await recoverySnackBoxAllGoodsApi(param)
    return res
  },
  // 获取零食盒子盘点统计
  async getSnackBoxInventoryCountAction(context, param) {
    const res = await getSnackBoxInventoryCountApi(param)
    return res
  },
  // 获取零食盒子数据总览
  async getSnackBoxDataOverviewAction(context, param) {
    const res = await getSnackBoxDataOverviewApi(param)
    return res
  },
  // 删除表白墙评论
  async deleConfessionWallEvaluateAction(context, param) {
    const res = await deleConfessionWallEvaluateApi(param)
    return res
  },
  // 查询零食盒子商品销售排行
  async querySnackBoxGoodsSalesRankingAction(context, param) {
    const res = await querySnackBoxGoodsSalesRankingApi(param)
    return res
  },
  // 查询公司订单和储备金流水
  async queryCompanyOrderAndReserveFundWaterAction(context, param) {
    const res = await queryCompanyOrderAndReserveFundWaterApi(param)
    return res
  },
  // 公司订单和储备金流水统计
  async getCompanyOrderAndReserveFundWaterCountAction(context, param) {
    const res = await getCompanyOrderAndReserveFundWaterCountApi(param)
    return res
  },
  // 删除零食盒子库存管理
  async deleteSnackBoxStockManageAction(context, param) {
    const res = await deleteSnackBoxStockManageApi(param)
    return res
  },
  // 删除零食盒子商品相关申请
  async deleteSnackBoxGoodsApplyAction(context, param) {
    const res = await deleteSnackBoxGoodsApplyApi(param)
    return res
  },
  // 获取自定义收费项目列表
  async getCustomChargeItemListAction({ getters, commit }) {
    let param = {
      brandId: getters.brandInfo.id
    }
    const res = await getCustomChargeItemListApi(param)
    if (res.Code === RES_OK) {
      let list = res.Result
      commit('setCustomChargeItemList', list)
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
